import { Modal, Typography } from '@getsynapse/design-system';
import { ModalProps } from '@getsynapse/design-system/dist/Organisms/Modal/Modal';
import intl from 'react-intl-universal';

export type DeleteLineItemModalProps = ModalProps & {
  onDeleteProgram: () => void;
  onCancel: () => void;
  title?: string;
};

export const DeleteLineItemModal = ({
  onDeleteProgram,
  onCancel,
  title,
  ...props
}: DeleteLineItemModalProps) => {
  return (
    <Modal
      data-cy='delete-line-item-modal'
      {...props}
      aria-label={intl.get('BUDGET_PAGE.DELETE_PROGRAM_MODAL.TITLE', {
        title: title,
      })}
      titleIcon={{
        name: 'trash',
        className: 'text-error',
      }}
      title={intl.get('BUDGET_PAGE.DELETE_PROGRAM_MODAL.TITLE')}
      size='small'
      actionButtons={[
        {
          children: intl.get('BUDGET_PAGE.DELETE_PROGRAM_MODAL.CONFIRM'),
          onClick: onDeleteProgram,
          'data-cy': 'remove-task_button',
          'data-testid': 'remove-task',
          variant: 'primary',
          color: 'danger',
        },
        {
          children: intl.get('CANCEL'),
          variant: 'tertiary',
          onClick: onCancel,
          'data-cy': 'cancel-task_button',
          'data-testid': 'cancel',
        },
      ]}
    >
      <Typography>
        {intl.get('BUDGET_PAGE.DELETE_PROGRAM_MODAL.CAPTION', { title: title })}
        {intl.get('BUDGET_PAGE.DELETE_PROGRAM_MODAL.WARNING')}
      </Typography>
    </Modal>
  );
};
